module.exports = __webpack_public_path__ + "img/selfGuided.e9f8b80e.jpg";